<template>
  <footer class="footer">
    <div class="container-fluid">
      <ul class="nav">
        <li class="nav-item">
        </li>
      </ul>
      <div class="copyright">
        © {{year}} Prism by <a href="https://www.netzeroanalytics.eu" target="_blank" rel="noopener">Net Zero Analytics</a>
      </div>
    </div>
  </footer>
</template>
<script>
  export default {
    data() {
      return {
        year: new Date().getFullYear()
      }
    }
  };
</script>
<style>
</style>
